import { Component, OnInit } from '@angular/core';
import {LanguageService} from './services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Certikap Front';

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.languageService.initialize();
  }
}
